import Axios from "axios";

export const CalendarEventsService =  {
    fetchEvents: (params) => {
        return Axios.get('/api/calendar-events', {params});
    },

    fetchEvent: (id) => {
        return Axios.get(`/api/calendar-events/${id}`);
    },

    saveEvent: (event) => {
        if (event.id) {
            return Axios.put('/api/calendar-events/'+event.id, event);
        }
        return Axios.post('/api/calendar-events', event);
    },

    deleteEvent: (event) => {
        return Axios.delete('/api/calendar-events/'+event.id);
    },

    toggleDay(date, user_id, type) {
        return Axios.post('/api/toggle-day', {
            user_id,
            date,
            type,
        });
    },
};

export default CalendarEventsService;


// WEBPACK FOOTER //
// ./resources/assets/js/services/CalendarEventsService.js